import React from "react";

export default function VKIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="20"
      viewBox="0 0 35 20"
    >
      <path d="M33.627.879h-5.68a1.28 1.28 0 0 0-1.13.68s-2.265 4.202-2.993 5.617c-1.957 3.807-3.225 2.611-3.225.845V1.929c0-1.06-.853-1.92-1.906-1.92h-4.27a3.411 3.411 0 0 0-3.022 1.413s2.168-.353 2.168 2.59c0 .729.038 2.828.072 4.588a1.268 1.268 0 0 1-.795 1.21c-.491.196-1.05.063-1.403-.333a37.524 37.524 0 0 1-4.312-7.898c-.196-.428-.62-.701-1.088-.7H.883a.875.875 0 0 0-.724.376.888.888 0 0 0-.104.814C1.622 6.398 8.37 20 16.075 20h3.243c.708 0 1.281-.578 1.281-1.29v-1.972c0-.506.299-.963.76-1.164.46-.2.995-.106 1.361.24l3.881 3.673c.349.33.81.513 1.288.513h5.096c2.458 0 2.458-1.718 1.118-3.047-.943-.936-4.347-4.549-4.347-4.549a1.78 1.78 0 0 1-.135-2.3c1.1-1.458 2.9-3.845 3.663-4.867 1.043-1.398 2.93-4.358.343-4.358z" />
    </svg>
  );
}
